// extracted by mini-css-extract-plugin
module.exports = {"btns":"_6pSei7Hw_l262q-Hyma4i"};